import { AppService } from './app.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/forkJoin'
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class HomepageResolver implements Resolve<any> {
    constructor(private appService: AppService, private router: Router) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        let language = route.params['language'];
        if (!environment.allowedLanguages[language]) {
            this.router.navigate(['/not-found']);
            return null;
        }
        return Observable.forkJoin(
            this.appService.getHomepage(language),
            this.appService.getPlatformFeatures(language),
            this.appService.getHomepageSlides(language),
            this.appService.getImagesGallery(),
            this.appService.getArticles(language),
            this.appService.getMenu(language)
        ).map(results => {
            let data: any = {};
            let homepage = results[0].json();
            data['homepage'] = (homepage[0] ? homepage[0] : {});
            data['platformFeatures'] = results[1].json();
            data['homepageSlides'] = results[2].json();
            data['galleryPictures'] = results[3].json();
            let menu = results[5].json();
            data['menu'] = (menu[0] ? menu[0] : {});
            data['articles'] = [];
            if (results[4]) {
                let articles = results[4].json();
                if (Array.isArray(articles)) {
                    articles.some((article) => {
                        if (data['articles'].length >= 3) {
                            return true;
                        }
                        data['articles'].push(article);
                        return false;
                    });
                }
            }
            return data;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/providers/homepage-resolver.service.ts